import { startOfDay } from 'date-fns';

import { type DayGroup } from '@/shared/config';

/**
 * Groups consecutive items that fall on the same local calendar day. The
 * input order is preserved, so a list sorted by date yields date-sorted
 * groups.
 */
export const groupByDay = <T>(
  items: T[],
  getDate: (item: T) => Date,
): DayGroup<T>[] =>
  items.reduce<DayGroup<T>[]>((groups, item) => {
    const dayDate = startOfDay(getDate(item));
    const dayKey = dayDate.getTime();
    const lastGroup = groups[groups.length - 1];

    if (lastGroup && lastGroup.dayKey === dayKey) {
      return [
        ...groups.slice(0, -1),
        { ...lastGroup, items: [...lastGroup.items, item] },
      ];
    }

    return [...groups, { dayDate, dayKey, items: [item] }];
  }, []);
